import './style.css'

export const Privacy = () => {
    return (
        <article className='container'>
            <header>
                <h1>política de privacidade - comandos.dev</h1>
            </header>
        
            <section>
                <h2>introdução</h2>
                <p>a sua privacidade é muito importante para nós. Esta Política de Privacidade tem como objetivo informar
                    como o <strong>comandos.dev</strong> coleta, usa, armazena e protege as informações pessoais dos seus
                    usuários.</p>
                <p>ao utilizar o site <strong>comandos.dev</strong> ("site"), você concorda com a coleta e o uso das suas
                    informações conforme descrito nesta Política de Privacidade.</p>
            </section>

            <section>
                <h2>informações coletadas</h2>
                <p>coletamos diferentes tipos de informações com o objetivo de fornecer um serviço melhor e mais
                    personalizado para os usuários. As informações podem ser coletadas de diferentes formas, como descrito
                    abaixo:</p>

                <h3>informações de navegação</h3>
                <p>também podemos coletar automaticamente informações sobre a sua interação com o site, incluindo:</p>
                <ul>
                    <li>endereço IP</li>
                    <li>tipo de navegador</li>
                    <li>sistema operacional</li>
                    <li>informações de cookies</li>
                    <li>dados de localização (se permitido)</li>
                </ul>

                <h3>cookies e tecnologias semelhantes</h3>
                <p>usamos <strong>cookies</strong> e tecnologias semelhantes para melhorar a experiência de navegação do
                    usuário, personalizar conteúdo, analisar o tráfego e realizar outras funções importantes para o
                    funcionamento do site.</p>
                <p>um <strong>cookie</strong> é um pequeno arquivo de texto armazenado no seu dispositivo que pode ser
                    utilizado para lembrar suas preferências ou fornecer outras funcionalidades.</p>
                <p>Você pode desativar os cookies no seu navegador, mas isso pode afetar a funcionalidade do site.</p>
            </section>

            <section>
                <h2>uso das informações</h2>
                <p>as informações que coletamos são usadas para os seguintes fins:</p>
                <ul>
                    <li><strong>fornecer e personalizar serviços:</strong> Usamos suas informações para criar e personalizar sua
                        experiência no <strong>comandos.dev</strong>, como salvar suas preferências e comandos favoritos.</li>
                    <li><strong>melhorar o Site:</strong> para analisar o uso do site e melhorar seu desempenho e funcionalidades.</li>
                    <li><strong>comunicação:</strong> podemos usar o seu e-mail para enviar notificações sobre atualizações, novos
                        comandos ou outros conteúdos relevantes. Você pode optar por não receber essas comunicações a qualquer
                        momento.</li>
                    <li><strong>segurança e cumprimento:</strong> utilizamos suas informações para garantir a segurança do site e
                        para cumprir com as leis e regulamentos aplicáveis.</li>
                </ul>
            </section>

            <section>
                <h2>compartilhamento de informações</h2>
                <p>nós não vendemos, alugamos ou trocamos suas informações pessoais com terceiros. No entanto, podemos compartilhar
                    suas informações nas seguintes circunstâncias:</p>
                <ul>
                    <li><strong>com prestadores de serviços:</strong> podemos compartilhar suas informações com fornecedores que
                        ajudam a operar o site (como servidores de hospedagem, processadores de pagamentos, etc.), mas esses
                        fornecedores não têm permissão para usar suas informações para outros fins.</li>
                    <li><strong>em caso de exigência legal:</strong> podemos divulgar suas informações pessoais se necessário para
                        cumprir com uma obrigação legal, proteger os direitos do site ou investigar atividades fraudulentas.</li>
                </ul>
            </section>

            <section>
                <h2>armazenamento e segurança dos dados</h2>
                <p>as informações pessoais que coletamos são armazenadas de maneira segura e protegidas por medidas de segurança
                    adequadas. No entanto, nenhuma transmissão de dados pela internet ou sistema de armazenamento é completamente
                    segura. Apesar de nossos esforços, não podemos garantir a segurança total de suas informações.</p>
            </section>

            <section>
                <h2>seus direitos</h2>
                <p>de acordo com a legislação de privacidade vigente, você tem o direito de:</p>
                <ul>
                    <li><strong>acessar:</strong> solicitar uma cópia das suas informações pessoais que temos armazenadas.</li>
                    <li><strong>corrigir:</strong> atualizar ou corrigir informações pessoais que estejam incorretas ou desatualizadas.</li>
                    <li><strong>excluir:</strong> solicitar a exclusão de suas informações pessoais, desde que não haja uma razão legal
                        para mantê-las.</li>
                    <li><strong>opor-se ao processamento:</strong> você pode, a qualquer momento, optar por não receber
                        comunicações ou retirar seu consentimento para o processamento de suas informações.</li>
                </ul>
                <p>se desejar exercer algum desses direitos, entre em contato conosco através do e-mail <a href="mailto:comandosdev@gmail.com">comandosdev@gmail.com</a>.</p>
            </section>

            <section>
                <h2>transferência internacional de dados</h2>
                <p>as informações pessoais coletadas podem ser transferidas e armazenadas em servidores localizados fora do seu país de residência. Se você estiver localizado fora do Brasil, saiba que podemos transferir seus dados para um país com leis de privacidade diferentes das do seu país. Ao utilizar o site, você concorda com a transferência e processamento de seus dados nessas condições.</p>
            </section>

            <section>
                <h2>links de terceiros</h2>
                <p>o <strong>comandos.dev</strong> pode conter links para sites de terceiros. Não somos responsáveis pelas práticas de
                    privacidade ou pelo conteúdo de sites externos. Ao clicar em links de terceiros, você deve revisar as políticas
                    de privacidade desses sites.</p>
            </section>

            <section>
                <h2>alterações nesta política de privacidade</h2>
                <p>o <strong>comandos.dev</strong> pode atualizar esta Política de Privacidade periodicamente. Quaisquer alterações
                    serão publicadas nesta página, com a data de revisão atualizada no topo. Recomendamos que você revise esta
                    política regularmente para estar ciente de como suas informações estão sendo protegidas.</p>
            </section>

            <section>
                <h2>contato</h2>
                <p>se você tiver dúvidas sobre esta Política de Privacidade ou sobre o uso das suas informações, entre em contato conosco através do e-mail <a href="mailto:comandosdev@gmail.com">comandosdev@gmail.com</a>.</p>
            </section>

        </article>
    );
};